module.exports = __webpack_public_path__ + "static/media/sort_down_icon.c200e166.svg";